export default __webpack_public_path__ + "static/media/controlBills24.2c4b1411.svg";